const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

export const isLovablePreviewHost = /--.*\.lovable\.app$/i.test(hostname);
export const shouldDisablePwaFeatures = isLovablePreviewHost;